




import { Vue, Component, Prop } from 'vue-property-decorator';
import { blockResolver } from '@/core/spa/componentResolver.service';
import { BaseBlockViewObject } from '@/types/apiServerContract';

@Component
export default class BlockRender extends Vue {
	@Prop({ required: true, type: Object })
	block!: BaseBlockViewObject;

	get resolvedBlock(): any {
	    return blockResolver.resolve(this.block.type);
	}
}
